import React, { useState } from "react";
import { Button, Typography, Box, Card, CircularProgress } from "@mui/material";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MasterLayout from "../../masterLayout/MasterLayout";
import { baseUrl } from "../../helper/urls";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
const moment = require("moment-timezone");
const generateNext30Days = () => {
  const days = [];
  const today = new Date();
  for (let i = 1; i <= 30; i++) {
    const nextDate = new Date(today);
    nextDate.setDate(today.getDate() + i);
    days.push({
      date: nextDate,
      label: `${nextDate.getDate()} ${nextDate.toLocaleString("default", {
        month: "short",
      })}`,
    });
  }
  return days;
};

const generate24Slots = () => {
  const slots = [];
  for (let i = 6; i < 22; i++) {
    const start = i.toString().padStart(2, "0") + ":00";
    const end = (i + 1).toString().padStart(2, "0") + ":00";
    slots.push(`${start} - ${end}`);
  }
  return slots;
};

const CalendarWithSlots = () => {
  const { token } = useSelector((state) => state.auth);
  const days = generateNext30Days();
  const slots = generate24Slots();

  const [selectedDateIndex, setSelectedDateIndex] = useState(null);
  const [selectedSlots, setSelectedSlots] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleSlotClick = (slot) => {
    setSelectedSlots((prev) =>
      prev.includes(slot) ? prev.filter((s) => s !== slot) : [...prev, slot]
    );
  };

  const handleSubmit = async () => {
    const selectedDate = days[selectedDateIndex].date;
    const formattedDate = selectedDate.toISOString().split("T")[0];
    const formattedSlots = selectedSlots.map((slot) => {
      const [start_time, end_time] = slot.split(" - ");
      const localStart = moment.tz(
        `${formattedDate} ${start_time}`,
        "YYYY-MM-DD HH:mm",
        Intl.DateTimeFormat().resolvedOptions().timeZone
      );
      const utcStart = localStart.utc().toDate();
      return { start_time, end_time, utcTime: utcStart.toISOString() };
    });

    const payload = {
      type: "College Counseling",
      date: formattedDate,
      slots: formattedSlots,
      time_zone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      // slots: allSlots,
    };
    setLoading(true);
    try {
      const response = await axios.post(
        `${baseUrl}/slots`,
        // {
        //   date: formattedDate,
        //   slots: formattedSlots,
        // },
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
            // 'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjb3Vuc2Vsb3JJZCI6MTksImVtYWlsIjoiZGVtb2NvdW5zZWxvckBkZGMuY29tIiwiZmlyc3ROYW1lIjoiRGVtbyIsImxhc3ROYW1lIjoiQ291bnNlbG9yIiwiaWF0IjoxNzQ3NzIwMDA3LCJleHAiOjE3NDc3NTYwMDd9.zGTVb0kjQo1jz7O6BSBHynUBxuhVUSwedBujhw7unmk'
          },
        }
      );
      toast.success("Slots submitted successfully!");
      setSelectedSlots([]);
      // setSelectedDateIndex(null);
    } catch (error) {
      toast.error("Failed to submit slots.");
      console.error("Error submitting slots:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <MasterLayout>
      <Box sx={{ p: 2 }}>
        <ToastContainer />
        <Typography variant="h6" gutterBottom>
          <div className="flex justify-center items-center text-center">
            <p className="justify-content-center">
              Please select a minimum of 1 available time slots for this month
              to open your calendar to students. <br />
              Reach out to {""}
              <Link to={"mailto:support@dreamdor.com"} target="_blank">
                support@dreamdor.com
              </Link>{" "}
              for any questions.
            </p>
          </div>
        </Typography>

        <Card sx={{ p: 2, mb: 4 }}>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
            {days.map((day, index) => (
              <Button
                key={index}
                variant={selectedDateIndex === index ? "contained" : "outlined"}
                sx={{
                  flex: "0 0 calc(10% - 8px)",
                  height: 45,
                  backgroundColor:
                    selectedDateIndex === index ? "#124178" : "inherit",
                  color: selectedDateIndex === index ? "#fff" : "inherit",
                  "&:hover": {
                    backgroundColor: "#124178",
                    color: "#fff",
                  },
                }}
                onClick={() => {
                  setSelectedDateIndex(index);
                  setSelectedSlots([]);
                }}
              >
                {day.label}
              </Button>
            ))}
          </Box>
        </Card>

        {selectedDateIndex !== null && (
          <>
            <Typography variant="h6" gutterBottom>
              Select Slots for {days[selectedDateIndex].date.toDateString()}{" "}
              (You can select multiple slots)
            </Typography>

            <Card sx={{ p: 2, mb: 2 }}>
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                {slots.map((slot, idx) => (
                  <Button
                    key={idx}
                    variant={
                      selectedSlots.includes(slot) ? "contained" : "outlined"
                    }
                    sx={{
                      flex: "0 0 calc(12.5% - 8px)",
                      height: 45,
                      backgroundColor: selectedSlots.includes(slot)
                        ? "#124178"
                        : "inherit",
                      color: selectedSlots.includes(slot) ? "#fff" : "inherit",
                      "&:hover": {
                        backgroundColor: "#124178",
                        color: "#fff",
                      },
                    }}
                    onClick={() => handleSlotClick(slot)}
                  >
                    {slot}
                  </Button>
                ))}
              </Box>
            </Card>

            <Button
              variant="contained"
              disabled={selectedSlots.length === 0 || loading}
              sx={{
                width: "100%",
                height: 45,
                backgroundColor: "#124178",
                "&:hover": {
                  backgroundColor: "#124178",
                  color: "#fff",
                },
              }}
              onClick={handleSubmit}
            >
              {loading ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Add Slot"
              )}
            </Button>
          </>
        )}
      </Box>
    </MasterLayout>
  );
};

export default CalendarWithSlots;

// import React, { useState } from 'react';
// import { Button, Typography, Box, Card } from '@mui/material';
// import axios from 'axios';
//  import MasterLayout from "../../masterLayout/MasterLayout";

// const generateNext30Days = () => {
//     const days = [];
//     const today = new Date();
//     for (let i = 1; i <= 30; i++) {
//         const nextDate = new Date(today);
//         nextDate.setDate(today.getDate() + i);
//         days.push({
//             date: nextDate,
//             label: `${nextDate.getDate()} ${nextDate.toLocaleString('default', { month: 'short' })}`,
//         });
//     }
//     return days;
// };

// const generate24Slots = () => {
//     const slots = [];
//     for (let i = 0; i < 24; i++) {
//         const start = i.toString().padStart(2, '0') + ':00';
//         const end = (i + 1).toString().padStart(2, '0') + ':00';
//         slots.push(`${start} - ${end}`);
//     }
//     return slots;
// };

// const CalendarWithSlots = () => {
// const token =sessionStorage.getItem("token")
//     const days = generateNext30Days();
//     const slots = generate24Slots();

//     const [selectedDateIndex, setSelectedDateIndex] = useState(null);
//     const [selectedSlots, setSelectedSlots] = useState([]);
//     console.log("selectedSlots: ", selectedSlots);

//     const handleSlotClick = (slot) => {
//         setSelectedSlots((prev) =>
//             prev.includes(slot) ? prev.filter((s) => s !== slot) : [...prev, slot]
//         );
//     };

//     const handleSubmit = async () => {
//         const selectedDate = days[selectedDateIndex].date;
//         const formattedDate = selectedDate.toISOString().split('T')[0]; // 'YYYY-MM-DD'
//         console.log("formattedDate: ", formattedDate);

//         const formattedSlots = selectedSlots.map((slot) => {
//             const [start_time, end_time] = slot.split(' - ');
//             return { start_time, end_time };
//         });
//             console.log("formattedSlots: ", formattedSlots);

//         try {
//             const response = await axios.post(
//                 'http://localhost:5000/slots',
//                 {
//                     date: formattedDate,
//                     slots: formattedSlots
//                 },
//                 {
//                     headers: {
//                         'Content-Type': 'application/json',
//                         'Authorization': `Bearer ${token}`
//                     },
//                     // withCredentials: true // if cookie/session is needed
//                 }
//             );
//             console.log('Response:', response.data);
//             alert('Slots submitted successfully!');
//         } catch (error) {
//             console.error('Error submitting slots:', error);
//             alert('Failed to submit slots.');
//         }
//     };

//     return (
//         <MasterLayout>
//         <Box sx={{ p: 2 }}>
//             <Typography variant="h6" gutterBottom>
//                 Select a Date
//             </Typography>

//             <Card sx={{ p: 2, mb: 4 }}>
//                 <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
//                     {days.map((day, index) => (
//                         <Button
//                             key={index}
//                             variant={selectedDateIndex === index ? 'contained' : 'outlined'}
//                             sx={{
//                                 flex: '0 0 calc(10% - 8px)',
//                                 height: 45,
//                                 backgroundColor: selectedDateIndex === index ? '#124178' : 'inherit',
//                                 color: selectedDateIndex === index ? '#fff' : 'inherit',
//                                 '&:hover': {
//                                     backgroundColor: '#124178',
//                                     color: '#fff',
//                                 },
//                             }}
//                             onClick={() => {
//                                 setSelectedDateIndex(index);
//                                 setSelectedSlots([]);
//                             }}
//                         >
//                             {day.label}
//                         </Button>
//                     ))}
//                 </Box>
//             </Card>

//             {selectedDateIndex !== null && (
//                 <>
//                     <Typography variant="h6" gutterBottom>
//                         Select Slots for {days[selectedDateIndex].date.toDateString()} (You can select multiple slots)
//                     </Typography>

//                     <Card sx={{ p: 2, mb: 2 }}>
//                         <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
//                             {slots.map((slot, idx) => (
//                                 <Button
//                                     key={idx}
//                                     variant={selectedSlots.includes(slot) ? 'contained' : 'outlined'}
//                                     sx={{
//                                         flex: '0 0 calc(12.5% - 8px)',
//                                         height: 45,
//                                         backgroundColor: selectedSlots.includes(slot) ? '#124178' : 'inherit',
//                                         color: selectedSlots.includes(slot) ? '#fff' : 'inherit',
//                                         '&:hover': {
//                                             backgroundColor: '#124178',
//                                             color: '#fff',
//                                         },
//                                     }}
//                                     onClick={() => handleSlotClick(slot)}
//                                 >
//                                     {slot}
//                                 </Button>
//                             ))}
//                         </Box>
//                     </Card>

//                     <Button
//                         variant="contained"
//                         disabled={selectedSlots.length === 0}
//                         sx={{
//                             width: '100%',
//                             height: 45,
//                             backgroundColor: '#124178',
//                             '&:hover': {
//                                 backgroundColor: '#124178',
//                                 color: '#fff',
//                             }
//                         }}
//                         onClick={handleSubmit}
//                     >
//                         Book Slot
//                     </Button>
//                 </>
//             )}
//         </Box>
//         </MasterLayout>
//     );
// };

// export default CalendarWithSlots;
